// extracted by mini-css-extract-plugin
export default {"container":"IconPlay_container__Y-Wjd"};